import {
    // GeomatiIcon,
    WasteDisposalIcon,
    ReportsIcon,
    LocationsIcon,
    // IOIcon,
    InformationIcon,
    ReceiverIcon,
    // HseIncidentIcon,
    RWPIcon,
    ConsumableUsageIcon,
    ActivityDiaryIcon,
    WorkboatIcon,
    HelicopterIcon,
    WeatherIcon,
    USVIcon,
    AcquisitionIcon,
    HseDiaryIcon,
    HealthIcon,
    MapIcon,
    ROVIcon,
    MMOIcon,
    // BudgetingIcon,
    ProLogSettingIcon,
    DashboardIcon,
    CompensationIcon,
    FleetSummaryIcon,
    DrillIcon,
    ClearanceIcon,
    LineClearanceIcon,
    NearSurfaceInspectionIcon,
    NonSeismicIcon,
    PermitIcon,
    LoadingIcon,
    MaterialsIcon,
    MeasurementIcon,
    PlanIcon,
    KnowledageIcon
} from 'assets/icons'
import { OnSiteProcessingIcon } from 'assets/icons/OnSiteProcessingIcon'
import { VehicleIcon } from 'assets/icons/VehicleIcon'
import { t } from 'i18next'

export const getNavDataList = (receiverTypeList) => [
    {
        label: t('nav.dashboard.label'),
        key: '/dashboard',
        icon: <DashboardIcon style={{ fontSize: '16px', position: 'relative' }} />,
        children: [
            {
                key: '/dashboard/projectOverview',
                label: t('nav.dashboard.children.projectOverview'),
                menuCode: 'dashboard_project_obn',
                permission: "dashboard:project_obn"
                // auth: 1,
            },
            {
                key: '/dashboard/projectOverviewStreamer',
                label: t('nav.dashboard.children.projectOverviewStreamer'),
                menuCode: 'dashboard_project_streamer',
                permission: "dashboard:project_streamer"
                // auth: 1,
            },
            {
                key: '/dashboard/projectOverviewLand',
                label: t('nav.dashboard.children.projectOverviewLand'),
                menuCode: 'dashboard_project_land',
                permission: "dashboard:project_land"
                // auth: 1,
            },
            {
                key: '/dashboard/HSEOverview',
                label: t('nav.dashboard.children.HSEOverview'),
                menuCode: 'dashboard_hse',
                permission: "dashboard:hse"
                // auth: 1,
            },
            {
                key: '/dashboard/sourceStatistics',
                label: t('nav.dashboard.children.sourceStatistics'),
                menuCode: 'dashboard_source_obn',
                permission: "dashboard:source_obn"
                // auth: 1,
            },
            {
                key: '/dashboard/sourceStatisticsLand',
                label: t('nav.dashboard.children.sourceStatisticsLand'),
                menuCode: 'dashboard_source_land',
                permission: "dashboard:source_land"
                // auth: 1,
            },
            {
                key: '/dashboard/sourceStatisticsStreamer',
                label: t('nav.dashboard.children.sourceStatisticsStreamer'),
                menuCode: 'dashboard_source_streamer',
                permission: "dashboard:source_streamer"
                // auth: 1,
            },
            {
                key: '/dashboard/receiverStatistics',
                label: t('nav.dashboard.children.receiverStatistics'),
                menuCode: 'dashboard_node_obn',
                permission: "dashboard:node_obn"
                // auth: 1,
            },
            {
                key: '/dashboard/receiverStatisticsLand',
                label: t('nav.dashboard.children.receiverStatisticsLand'),
                menuCode: 'dashboard_node_land',
                permission: "dashboard:node_land"
                // auth: 1,
            },
            {
                key: '/dashboard/ConsumableOverview',
                label: t('nav.dashboard.children.ConsumableOverview'),
                menuCode: 'dashboard_consumable',
                permission: "dashboard:consumable"
                // auth: 1,
            },
            {
                key: '/dashboard/timingStatistics',
                label: t('nav.dashboard.children.timingStatistics'),
                menuCode: 'dashboard_timing',
                permission: "dashboard:timing"
                // auth: 1,
            },
            {
                key: '/dashboard/ProfitIncome',
                label: t('nav.dashboard.children.profitIncome'),
                menuCode: 'dashboard_income',
                permission: "dashboard:income"
                // auth: 1,
            },
        ],
    },
    {
        label: t('nav.production.label'),
        type: 'group',
        key: 'production',
        children: [
            {
                key: '/project_summary',
                label: t('nav.production.children.FleetSummary'),
                icon: <FleetSummaryIcon style={{ fontSize: '20px', paddingRight: '1px' }} />,
                menuCode: 'project_summary',
                permission: "monitor:project_summary",
            },
            {
                key: '/hse_diary',
                label: t('nav.production.children.HseDiary'),
                icon: <HseDiaryIcon style={{ fontSize: '19px' }} />,
                menuCode: 'hse_diary',
                permission: "monitor:hse_diary",
                dict: [
                    'hse_card_type',
                    'hse_company',
                    'hse_event',
                    'hse_personnel_type',
                    'hse_exposure_hours',
                    'hse_incident_type',
                ],
            },
            {
                key: '/health_diary',
                label: t('nav.production.children.OccupationalHealth'),
                icon: <HealthIcon style={{ fontSize: '18px' }} />,
                menuCode: 'health_diary',
                permission: "monitor:health_diary",
                dict: [
                    'health_event',
                ],
            },

            {
                key: '/rwp',
                label: t('nav.production.children.RWP'),
                icon: <RWPIcon style={{ fontSize: '17px', paddingLeft: '1px' }} />,
                menuCode: 'rwp',
                permission: "monitor:rwp",
                dict: ['rwp_company', 'rwp_priority', 'rwp_responsible', 'rwp_status', 'rwp_source', 'rwp_department', 'rwp_hazard_cat_1', 'rwp_hazard_cat_2', 'rwp_consequence', 'rwp_uauc'],
            },
            {
                key: '/consumable',
                label: t('nav.production.children.Consumable'),
                icon: <ConsumableUsageIcon style={{ fontSize: '19px', paddingLeft: '1px' }} />,
                menuCode: 'consumable',
                permission: "monitor:consumable",
                dict: ['consumable_standard_type', 'consumable_use_type', 'consumable_unit_type'],
            },
            {
                key: '/waste_disposal',
                label: t('nav.production.children.Waste'),
                icon: <WasteDisposalIcon style={{ fontSize: '20px' }} />,
                menuCode: 'waste_disposal',
                permission: "monitor:waste_disposal",
                dict: ['waste_standard_type', 'waste_disposal_type', 'waste_hazardous_type', 'waste_unit_type'],
            },
            {
                key: '/acquisition_obn',
                label: t('nav.production.children.Acquisition'),
                icon: <AcquisitionIcon style={{ fontSize: '24px' }} />,
                menuCode: 'acquisition_obn',
                permission: "monitor:acquisition_obn",
                dict: ['acquisition_type', 'acquisition_status', 'acquisition_area_type'],
            },
            {
                key: '/acquisition_streamer',
                label: t('nav.production.children.Source'),
                icon: <AcquisitionIcon style={{ fontSize: '24px' }} />,
                menuCode: 'acquisition_streamer',
                permission: "monitor:acquisition_streamer",
                dict: ['streamer_type', 'streamer_status', 'streamer_construction_type'],
            },
            {
                key: '/lineClearance',
                label: t('nav.production.children.LineClearance'),
                icon: <LineClearanceIcon style={{ fontSize: '20px' }} />,
                menuCode: 'line_clearance',
                permission: "monitor:line_clearance",
                dict: ['landnode_group_name_line_clearence', 'landnode_type'],
            },
            {
                key: '/clearance',
                label: t('nav.production.children.Clearance'),
                icon: <ClearanceIcon style={{ fontSize: '20px' }} />,
                menuCode: 'mine_clearance',
                permission: "monitor:mine_clearance",
                dict: ['landnode_group_name_mine_clearence', 'landnode_type'],
            },
            {
                key: '/measurement',
                label: t('nav.production.children.Measurement'),
                icon: <MeasurementIcon style={{ fontSize: '20px' }} />,
                menuCode: 'measurement',
                permission: "monitor:measurement",
                dict: ['landnode_group_name_measure', 'landnode_type_measure'],
            },
            {
                key: '/drill',
                label: t('nav.production.children.Drill'),
                icon: <DrillIcon style={{ fontSize: '20px' }} />,
                menuCode: 'drill',
                permission: "monitor:drill",
                dict: ['landnode_group_name_drill'],
            },
            {
                key: '/loading',
                label: t('nav.production.children.Loading'),
                icon: <LoadingIcon style={{ fontSize: '24px' }} />,
                menuCode: 'loading',
                permission: "monitor:loading",
                dict: ['landnode_group_name_loading', 'landnode_type_loading', 'landnode_unit_loading', 'landnode_use_type_loading'],
            },
            {
                key: '/receiver_land',
                label: t('nav.production.children.ReceiveLand'),
                icon: <ReceiverIcon style={{ fontSize: '16px' }} />,
                menuCode: 'receiver_land',
                permission: "monitor:receiver_land",
                dict: ['landnode_group_name_receiver', 'receiver_activity', 'receiver_status', 'receiver_method', 'receiver_line_type'],
            },
            {
                key: '/vibrator',
                label: t('nav.production.children.Focus'),
                icon: <AcquisitionIcon style={{ fontSize: '24px' }} />,
                menuCode: 'acquisition_vibrator',
                permission: "monitor:acquisition_vibrator",
                dict: ['landnode_activity_type_quacksource'],
            },
            {
                key: '/receiver',
                label: t('nav.production.children.Receive'),
                icon: <ReceiverIcon style={{ fontSize: '16px' }} />,
                menuCode: 'receiver_obn',
                permission: "monitor:receiver_obn",
                dict: ['receiver_activity', 'receiver_status', 'receiver_method', 'receiver_line_type'],
            },
            {
                key: '/activity_diary',
                label: t('nav.production.children.ActivityDiary'),
                icon: <ActivityDiaryIcon style={{ fontSize: '17px', paddingLeft: '1px' }} />,
                menuCode: 'activity_diary',
                permission: "monitor:activity_diary",
                dict: ['activity_type', 'daily_challenge_category'],
            },
            {
                key: '/nearSurfaceInspection',
                label: t('nav.production.children.NearSurfaceInspection'),
                icon: <NearSurfaceInspectionIcon style={{ fontSize: '24px' }} />,
                menuCode: 'near_surface_inspection',
                permission: "monitor:near_surface_inspection",
                dict: ['landnode_group_name_near_surface', 'landnode_type_near_surface'],
            },
            {
                key: '/permit',
                label: t('nav.production.children.Permit'),
                icon: <PermitIcon style={{ fontSize: '20px' }} />,
                menuCode: 'permit',
                permission: "monitor:permit",
                dict: ['landnode_group_name_permit', 'landnode_type_permit'],
            },
            {
                key: '/nonSeismic',
                label: t('nav.production.children.NonSeismic'),
                icon: <NonSeismicIcon style={{ fontSize: '24px' }} />,
                menuCode: 'non_seismic',
                permission: "monitor:non_seismic",
                dict: ['landnode_group_name_non_sesmic'],
            },
            {
                key: '/magnetism',
                label: t('nav.production.children.magnetism'),
                icon: <AcquisitionIcon style={{ fontSize: '24px' }} />,
                menuCode: 'magnetic_gravity',
                permission: "monitor:magnetic_gravity",
                dict: ['magnatic_gravity_type', 'streamer_type'],
            },
            {
                key: '/onSiteProcessing',
                label: t('nav.production.children.OnSiteProcessing'),
                icon: <OnSiteProcessingIcon style={{ fontSize: '22px' }} />,
                menuCode: 'on_site_processing',
                permission: "monitor:on_site_processing",
            },
            {
                key: '/vehicle',
                label: t('nav.production.children.Vehicle'),
                icon: <VehicleIcon style={{ fontSize: '20px' }} />,
                menuCode: 'vehicle',
                permission: "monitor:vehicle",
                dict: ['landnode_group_name_vehicle', 'landnode_type_vehicle', 'equipment_status'],
            },
            {
                key: '/materials',
                label: t('nav.production.children.Materials'),
                icon: <MaterialsIcon style={{ fontSize: '20px' }} />,
                menuCode: 'materials',
                permission: "monitor:materials",
                dict: ['landnode_group_name_materials', 'landnode_type_materials'],
            },
            {
                key: '/rov',
                label: t('nav.production.children.ROV'),
                icon: <ROVIcon style={{ fontSize: '24px' }} />,
                menuCode: 'rov',
                permission: "monitor:rov",
                dict: ['rov_name', 'rov_activity'],
            },
            {
                key: '/usv',
                label: t('nav.production.children.USV'),
                icon: <USVIcon style={{ fontSize: '19px' }} />,
                menuCode: 'usv',
                permission: "monitor:usv",
                dict: ['usv_name', 'usv_activity'],
            },
            {
                key: '/work_boat',
                label: t('nav.production.children.Workboat'),
                icon: <WorkboatIcon style={{ fontSize: '20px' }} />,
                menuCode: 'work_boat',
                permission: "monitor:workboat",
                dict: ['workboat_name', 'workboat_task'],
            },
            {
                key: '/helicopter',
                label: t('nav.production.children.Helicopter'),
                icon: <HelicopterIcon style={{ fontSize: '18px' }} />,
                menuCode: 'helicopter',
                permission: "monitor:helicopter",
                dict: ['helicopter_name', 'helicopter_activity', 'landnode_helicopter_type_loading'],
            },
            {
                key: '/weather',
                label: t('nav.production.children.Weather'),
                icon: <WeatherIcon style={{ fontSize: '19px' }} />,
                menuCode: 'weather',
                permission: "monitor:weather",
                dict: ['swell_direction', 'wind_direction', 'current_direction', 'swell_height', 'weather_wind_speed_unit', 'weather_situation'],
            },
            {
                key: '/mmo',
                label: t('nav.production.children.MMO'),
                icon: <MMOIcon style={{ fontSize: '20px' }} />,
                menuCode: 'mmo',
                permission: "monitor:mmo",
                dict: ['observer', 'observer_type'],
            },   
        ],
    },
    {
        label: t('nav.functions.label'),
        type: 'group',
        key: 'functions',
        children: [
            {
                key: '/functions/map',
                label: t('nav.functions.children.Map'),
                icon: <MapIcon style={{ fontSize: '21px' }} />,
                menuCode: 'maps',
                permission: "maps:maps_view",
            },
            {
                key: '/functions/report',
                label: t('nav.functions.children.Report'),
                icon: <ReportsIcon style={{ fontSize: '19px' }} />,
                menuCode: 'setting:report',
                permission: "setting:report",
            },
        ],
    },
    {
        label: t('nav.setting.label'),
        type: 'group',
        key: 'setting',
        children: [
            {
                key: '/setting/configuration',
                label: t('nav.setting.children.projectDetails.label'),
                icon: <InformationIcon style={{ fontSize: '18px' }} />,
                children: [
                    {
                        key: '/setting/projectDetails/projectConfig',
                        label: t('nav.setting.children.projectDetails.projectConfig'),
                        menuCode: 'setting:project',
                        permission: "setting:project",
                    },
                    {
                        key: '/setting/projectDetails/geometry',
                        label: t('nav.setting.children.projectDetails.geometry'),
                        menuCode: 'setting:geometry',
                        permission: "setting:geometry",
                    },
                    {
                        key: '/setting/projectDetails/terrain',
                        label: t('nav.setting.children.projectDetails.terrain'),
                        menuCode: 'setting:terrain',
                        permission: "setting:terrain",
                    },
                    {
                        key: '/setting/projectDetails/workload',
                        label: t('nav.setting.children.projectDetails.workload'),
                        menuCode: 'setting:workload',
                        permission: "setting:workload",
                    },
                    {
                        key: '/weekly_plan',
                        label: t('nav.plan.children.weeklyPlan'),
                        menuCode: 'setting:workload',
                        permission: "setting:workload"
                    },
                    {
                        key: '/setting/projectDetails/Zipper',
                        label: t('nav.setting.children.projectDetails.Zipper'),
                        menuCode: 'setting:zipper',
                        permission: "setting:zipper",
                    },
                    {
                        key: '/setting/projectDetails/Boundaries',
                        label: t('nav.setting.children.projectDetails.Boundaries'),
                        menuCode: 'setting:boundaries',
                        permission: "setting:boundaries",
                    },
                    {
                        key: '/setting/projectDetails/Obstacles',
                        label: t('nav.setting.children.projectDetails.Obstacles'),
                        menuCode: 'setting:boundaries',
                        permission: "setting:boundaries",
                    },
                ],
            },
            {
                key: '/setting/resources',
                label: t('nav.setting.children.resources.label'),
                icon: <LocationsIcon style={{ fontSize: '19px', position: 'relative' }} />,
                children: [
                    {
                        key: '/setting/resources/companys',
                        label: t('nav.setting.children.resources.companys'),
                        menuCode: 'setting:companies',
                        permission: "setting:companies",
                    },
                    {
                        key: '/setting/resources/locations',
                        label: t('nav.setting.children.resources.locations'),
                        menuCode: 'setting:location',
                        permission: "setting:location",
                    },
                    {
                        key: '/setting/resources/users',
                        label: t('nav.setting.children.resources.users'),
                        menuCode: 'setting:project_user',
                        permission: "setting:project_user",
                    },

                    {
                        key: '/setting/resources/equipment',
                        label: t('nav.setting.children.resources.equipment.title'),
                        children: [
                            {
                                key: '/setting/resources/equipment/EquipmentTransfer',
                                label: t('nav.setting.children.plan.equipmentTransfer'),
                                menuCode: 'setting:equipment_transfer',
                                permission: "setting:equipment_transfer",
                                dict: ['equipment_transfer_status'],
                            },
                            {
                                key: '/setting/resources/equipment/sourceSystem',
                                label: t('nav.setting.children.resources.equipment.sourceSystem'),
                                menuCode: 'setting:source',
                                permission: "setting:source",
                            },
                            {
                                key: '/setting/resources/equipment/receiverSystem',
                                label: t('nav.setting.children.resources.equipment.receiverSystem'),
                                menuCode: 'seeting:receiver',
                                permission: "setting:receiver",
                            },
                            {
                                key: '/setting/resources/equipment/recordingSystem',
                                label: t('nav.setting.children.resources.equipment.recordingSystem'),
                                menuCode: 'setting:recording',
                                permission: "setting:recording",
                            },
                        ],
                    },
                ],
            },
            /* 计划 */
            {
                key: '/setting/plan',
                label: t('nav.setting.children.plan.label'),
                icon: <PlanIcon style={{ fontSize: '16px', position: 'relative' }} />,
                children: [
                    {
                        key: '/setting/plan/MobilisationPlan',
                        label: t('nav.setting.children.plan.MobilisationPlan'),
                        menuCode: 'setting:mobilisation_plan',
                        permission: "setting:mobilisation_plan",
                    },
                    {
                        key: '/setting/plan/ProjectPlanLandNode',
                        label: t('nav.setting.children.plan.ProjectPlanLandNode'),
                        menuCode: 'setting:project_plan_landNode',
                        permission: "setting:project_plan_landNode",
                        dict: ['landnode_group_name_production_plan', 'landnode_unit_production_plan']
                    },
                    {
                        key: '/setting/plan/EquipmentPlan',
                        label: t('nav.setting.children.plan.EquipmentPlan'),
                        menuCode: 'setting:equipment_plan',
                        permission: "setting:equipment_plan",
                        dict: ['landnode_unit_equipment_plan']
                    },
                    {
                        key: '/setting/plan/PersonnelPlan',
                        label: t('nav.setting.children.plan.PersonnelPlan'),
                        menuCode: 'setting:personnel_plan',
                        permission: "setting:personnel_plan",
                        dict: ['landnode_group_name_vehicle', 'landnode_project_type_personnel_plan'],
                    },
                    {
                        key: '/setting/plan/MaterialPlan',
                        label: t('nav.setting.children.plan.materialPlan'),
                        menuCode: 'setting:material_plan',
                        permission: "setting:material_plan",
                    },
                    {
                        key: '/setting/plan/BudgetQuotation',
                        label: t('nav.setting.children.plan.BudgetQuotation'),
                        menuCode: 'setting:budget_quotation',
                        permission: "setting:budget_quotation",
                    },
                ],
            },
            {
                key: '/setting/Compensation',
                label: t('nav.setting.children.Compensation'),
                icon: <CompensationIcon style={{ fontSize: '18px', position: 'relative' }} />,
                menuCode: 'setting:price',
                permission: "setting:price",
            },
            {
                key: '/setting/LogSettings',
                label: t('nav.setting.children.LogSettings'),
                icon: <ProLogSettingIcon style={{ fontSize: '18px', position: 'relative' }} />,
                menuCode: 'setting:dict',
                permission: "setting:dict",
            },
            {
                key: '/setting/OperationManual',
                label: t('nav.setting.children.OperationManual'),
                icon: <KnowledageIcon style={{ fontSize: '18px', position: 'relative' }} />,
                menuCode: 'setting:dict',
                permission: "setting:dict",
            },
            // {
            //     key: '/setting/geomatic',
            //     label: t('nav.setting.children.geomatic'),
            //     icon: <GeomatiIcon style={{ fontSize: '19px' }} />,
            //     menuCode: 'setting:geomatic',
            // },
        ],
    },
]
